import { LoadingBlock, Table } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'
import InfiniteScroll from 'react-infinite-scroller'

import { useQueryParamFiltering } from '../../OptimizationProcesses/OptimizationProcessesList/useQueryParamFiltering'
import { BulkActionByFilterButton } from '../BulkActionByFilterButton'
import { GeometryAnomaliesPanel } from '../GeometryAnomaliesPanel/GeometryAnomaliesPanel'
import { useStyles } from './DrugRegistryList.styles'
import { useColumns } from './useColumns'
import { FilterKey, useDrugRegistry } from './useDrugRegistry'

export const DrugRegistryList = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { filtering, sorting, handleSort, handleFilter } =
    useQueryParamFiltering<FilterKey>()

  const { data, isEmpty, isFetching, hasNextPage, fetchNextPage, count } =
    useDrugRegistry({
      sorting,
      filtering,
    })

  const columns = useColumns({ sorting, filtering, handleSort, handleFilter })

  return (
    <InfiniteScroll
      loadMore={() => fetchNextPage()}
      hasMore={hasNextPage}
      loader={<LoadingBlock message={t('Loading')} key="loading" />}
    >
      <GeometryAnomaliesPanel
        isFilterActive={filtering.geometryAnomaly === 'true'}
        onFilter={(value) => handleFilter('geometryAnomaly', value)}
      />
      <div className={classes.toolbar}>
        <BulkActionByFilterButton
          filtering={filtering}
          resultCount={count}
          isFetching={isFetching}
        />
      </div>
      <div className={classes.tableWrapper}>
        <Table
          columns={columns}
          data={data}
          alternateRows
          stickyHeader
          isEmpty={isEmpty}
          emptyMessage={t('No results match your search criteria')}
        />
      </div>
    </InfiniteScroll>
  )
}
